export const normalizeToUTCDate = (date) => {
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        const [year, month, day] = date.split('-').map(Number);
        return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
    }
    const inputDate = new Date(date);
    if (isNaN(inputDate.getTime())) {
        throw new Error(`Invalid date input: ${date}`);
    }
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth();
    const day = inputDate.getDate();
    return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
};
export const formatDateString = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) {
        throw new Error(`Invalid date input: ${date}`);
    }
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
export const addMonthsUTC = (date, months) => {
    const result = new Date(date);
    const targetMonth = result.getUTCMonth() + months;
    const targetDay = result.getUTCDate();
    result.setUTCDate(1);
    result.setUTCMonth(targetMonth);
    const lastDayOfMonth = new Date(Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0)).getUTCDate();
    result.setUTCDate(Math.min(targetDay, lastDayOfMonth));
    return result;
};
export const isSameDay = (date1, date2) => {
    const d1 = normalizeToUTCDate(date1);
    const d2 = normalizeToUTCDate(date2);
    return d1.getTime() === d2.getTime();
};
//# sourceMappingURL=date.utils.js.map